export const RGN_TERM = {
	'44250': '계룡시',
	'44710': '금산군',
	'44150': '공주시',
	'44230': '논산시',
	'44270': '당진시',
	'44180': '보령시',
	'44760': '부여군',
	'44210': '서산시',
	'44770': '서천군',
	'44200': '아산시',
	'44810': '예산군',
	'44130': '천안시',
	'44790': '청양군',
	'44825': '태안군',
	'44800': '홍성군',
}

export const RENEW_DASH_DIR = {
	N: 'top',
	E: 'right',
	S: 'bottom',
	W: 'left'
};

export const RENEW_DASH_COLOR = [
	{ bgColor: '#BDE3FF', color: '#000' },
	{ bgColor: '#6BAAD7', color: '#fff' },
	{ bgColor: '#246797', color: '#fff' },
	{ bgColor: '#003357', color: '#fff' },
];

export const RENEW_ENSO_STATUS = {
	15001: {
		title: '태양광',
		img: '/images/renewStat/ensoStatus/sola.svg',
		geneTerm: '전기 에너지',
		instCapaUnit: 'MW',		
	},
	15002: {
		title: '태양열',
		img: '/images/renewStat/ensoStatus/heat.svg',
		geneTerm: '열 에너지',
		instCapaUnit: '㎡',
	},
	15003: {
		title: '지열',
		img: '/images/renewStat/ensoStatus/heath.svg',
		geneTerm: '열 에너지',
		instCapaUnit: 'MW',
	},
	15004: {
		title: '기타 에너지원',
		img: '/images/renewStat/ensoStatus/velo.svg',
		geneTerm: '전기 에너지',
		instCapaUnit: 'MW',
	},
}